import { useEffect } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useAuth } from '@lib/auth/use-auth.ts'

type LoginSearch = {
    invitation?: string
    organization?: string
    returnTo?: string
    env?: 'prod' | 'dev' | 'local'
}

const resolveTargetOrigin = (env?: LoginSearch['env']) => {
    switch (env) {
        case 'local':
            return 'http://localhost:3001';
        case 'dev':
            return 'https://dev.app.tymely.ai';
        case 'prod':
        default:
            return 'https://app.tymely.ai';
    }
};


const LoginRouteComponent = () => {
    const { loginWithRedirect, isAuthenticated, isLoading } = useAuth();
    const search = Route.useSearch() as LoginSearch;

    useEffect(() => {
        const targetOrigin = resolveTargetOrigin(search.env);
        const currentOrigin = window.location.origin;

        if (targetOrigin !== currentOrigin) {
            const url = new URL(`${targetOrigin}/login`)

            if (search.invitation) {
                url.searchParams.set('invitation', search.invitation);
            }

            if (search.organization) {
                url.searchParams.set('organization', search.organization);
            }

            if (search.env) {
                url.searchParams.set('env', search.env);
            }

            if (search.returnTo) {
                url.searchParams.set('returnTo', search.returnTo);
            }

            window.location.assign(url.toString())
            return;
        }

        if (isLoading || isAuthenticated) {
            return;
        }

        const returnTo = search.returnTo ?? '/'

        loginWithRedirect({
            appState: { returnTo },
            authorizationParams: {
                ...(search.invitation ? { invitation: search.invitation } : {}),
                ...(search.organization ? { organization: search.organization } : {}),
            },
        })
    }, [isLoading, isAuthenticated, loginWithRedirect, search.invitation, search.organization, search.returnTo, search.env])

    return <div>Redirecting...</div>
};

export const Route = createFileRoute('/login')({
    component: LoginRouteComponent,
});
